"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBN = exports.toNumber = exports.cleanObjKeys = void 0;
var web3_1 = __importDefault(require("web3"));
function cleanObjKeys(data) {
    return Object.keys(data).reduce(function (acc, key) {
        if (!key.match(/^[0-9]+$/)) {
            acc[key] = data[key];
        }
        return acc;
    }, {});
}
exports.cleanObjKeys = cleanObjKeys;
var toNumber = function (v) { return parseInt(v, 10); };
exports.toNumber = toNumber;
var toBN = function (v) { return (web3_1.default.utils.isBN(v) ? v : web3_1.default.utils.toBN(v)); };
exports.toBN = toBN;
